class Header {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    $('.js-drawer-trigger').click(function () {
      $(this).toggleClass('is-active');
      $('.js-drawer-inner').toggleClass('is-active');
      $('.js-header, .js-header *').toggleClass('is-h-color');
      scrollBan();
    })

    // ヘッダー内のアンカーリンククリック時の対応
    $('.js-header-smooth-link').on('click', function (event) {
      var target = $(this.getAttribute('href'));

      if (target.length) {
        event.preventDefault();
        $('.js-drawer-trigger').removeClass('is-active');
        $('.js-drawer-inner').removeClass('is-active');
        $('.js-header, .js-header *').removeClass('is-h-color');
        scrollBan();
        setTimeout(() => {
          $('html, body').stop().animate({
            scrollTop: target.offset().top // スクロール位置を調整
          }, 500);
        }, 300)
      }
    });

    if ($('.js-header').hasClass('top')) {

      gsap.to('.js-h-show', { // .box => アニメーションさせる要素
        scrollTrigger: {
          trigger: "body",
          start: "+=600",
          onEnter: () => {
            $('html').addClass('is-h-show');
            $('.js-header, .js-header *').addClass('is-h-show');
          },
          onLeaveBack: () => {
            $('html').removeClass('is-h-show');
            $('.js-header, .js-header *').removeClass('is-h-show');
          },
        }
      });
    } else {
      $('html').addClass('is-h-show');
      $('.js-header, .js-header *').addClass('is-h-show');
    }

    gsap.to('.js-header', { // .box => アニメーションさせる要素
      scrollTrigger: {
        trigger: "js-header",
        start: "top top",
        end: "top+=100 top",
        onEnter: () => {
          $('html').addClass('is-h-hidden');
          $('.js-header, .js-header *').addClass('is-h-hidden');
        },
        onLeaveBack: () => {
          $('html').removeClass('is-h-hidden');
          $('.js-header, .js-header *').removeClass('is-h-hidden');
        },
      }
    });

    // クエリを定義
    const mediaQuery = window.matchMedia('(max-width: 767px)')

    if (mediaQuery.matches) {
      $(".js-header-accordion").click(function (e) {
        e.preventDefault();
        const dataAttr = $(this).attr('data-attr');
        if (dataAttr) {
          location.href = dataAttr;
        } else {
          $(this).next().slideToggle();
          $(this).toggleClass('is-active');
        }
      })
      $(".js-header-accordion .plus").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().next().slideToggle();
        $(this).parent().toggleClass('is-active');
      })
    }
  }
}
